import { create } from "zustand";

const useSignupStore = create((set) => ({
    loginId: "",
    password: "",
    name: "",
    email: "",
    phoneNumber: "",
    birth: "",
    authNumber: "",
    timeStamp: "",
    marketingOptIn: false,
    isLoading: false,
    error: null,
    setMarketingOptIn: (consent) => set({ marketingOptIn: consent }),
    setPersonalInfo: (info) => set(info),
    setAccountInfo: (info) => set(info),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    resetForm: () =>
        set({
            loginId: "",
            password: "",
            name: "",
            email: "",
            phoneNumber: "",
            birth: "",
            authNumber: "",
            timeStamp: "",
            marketingOptIn: false,
            error: null,
        }),
}));

export default useSignupStore;
